<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="12" class="my-2">
        <div class="p-3">
          <b-row>
            <b-col cols="12" md="12" class="mb-3">
              <strong
                class="fs_16"
                v-text="$lang.finalReportInterviewResourcesTitle"
              />

              <b-list-group class="mt-3">
                <b-list-group-item
                  @click="goToPerson"
                  href="#"
                  class="text-info"
                >
                  <b-row align-h="center" align-v="center">
                    <b-col cols="12" md="10">
                      <i :class="`fas fa-user mr-2 text-secondary`" />
                      <strong v-text="`${$lang.person} ${personFullName}`" />
                    </b-col>
                    <b-col cols="12" md="2">
                      <b-button
                        block
                        variant="info"
                        class="text-white"
                        v-text="$lang.editView"
                      />
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item
                  @click="updateModal(true)"
                  href="#"
                  class="text-info"
                >
                  <b-row align-h="center" align-v="center">
                    <b-col cols="12" md="10">
                      <attachmentModal
                        :attachmentModel="showAttachmentModal"
                        :code="personCode"
                        :title="$lang.tabSixAttachmentListTitle"
                        @updateModal="updateModal"
                      >
                        <template slot="clickArea">
                          <i :class="`fas fa-paperclip mr-2 text-secondary`" />
                          <strong v-text="$lang.tabSixAttachmentListTitle" />
                        </template>
                      </attachmentModal>
                    </b-col>
                    <b-col cols="12" md="2">
                      <b-button
                        block
                        variant="info"
                        class="text-white"
                        v-text="$lang.editView"
                      />
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item
                  href="#"
                  class="text-info"
                  v-for="(item, index) in interview"
                  :key="index"
                  @click="showExamPacks(item)"
                >
                  <b-row align-h="center" align-v="center">
                    <b-col cols="12" md="10">
                      <i :class="`fas fa-calendar-check mr-2 text-secondary`" />
                      <strong
                        v-text="renderExecuteCaption(item, 'interview')"
                      />
                    </b-col>
                    <b-col cols="12" md="2">
                      <b-button
                        block
                        variant="info"
                        class="text-white"
                        v-text="$lang.editView"
                      />
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item
                  href="#"
                  class="text-info"
                  v-for="(item, index) in research"
                  :key="index"
                  @click="showExamPacks(item)"
                >
                  <b-row align-h="center" align-v="center">
                    <b-col cols="12" md="10">
                      <i :class="`fas fa-search mr-2 text-secondary`" />
                      <strong v-text="renderExecuteCaption(item, 'research')" />
                    </b-col>
                    <b-col cols="12" md="2">
                      <b-button
                        block
                        variant="info"
                        class="text-white"
                        v-text="$lang.editView"
                      />
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </div>
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          size="xl"
          v-model="showAzmoonLinksModal"
          ok-only
          hide-header
          :ok-title="$lang.close"
          @ok="showAzmoonLinksModal = false"
        >
          <AzmoonExecuteLinks
            :azmoonExecuteId="
              pathOr(
                '',
                ['azmoon_execute', 'id'],
                currentAzmoonExamPackItem
              ).toString()
            "
            :personCode="
              pathOr(
                '',
                ['person', 'parvandeh_code'],
                currentAzmoonExamPackItem
              ).toString()
            "
            :operatorCode="
              pathOr(
                '',
                ['operator', 'parvandeh_code'],
                currentAzmoonExamPackItem
              ).toString()
            "
            :referenceCode="
              pathOr(
                '',
                ['reference', 'code'],
                currentAzmoonExamPackItem
              ).toString()
            "
          />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import AzmoonExecuteLinks from "@/components/global/AzmoonExecuteLinks";
import attachmentModal from "./attachmentModal.vue";

export default {
  components: {
    AzmoonExecuteLinks,
    attachmentModal,
  },
  data() {
    return {
      code: this.$route.params.code,
      resourcesData: {},
      showAzmoonLinksModal: false,
      currentAzmoonExamPackItem: {},
      showAttachmentModal: false,
      personCode: "",
    };
  },
  computed: {
    interview() {
      return pathOr([], ["interview"], this.resourcesData);
    },
    research() {
      return pathOr([], ["research"], this.resourcesData);
    },
    personFullName() {
      return (
        pathOr([], ["person", "name"], this.resourcesData) +
        " " +
        pathOr([], ["person", "family"], this.resourcesData)
      );
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    updateModal(data) {
      this.showAttachmentModal = data;
    },
    goToPerson() {
      const routeData = this.$router.resolve({
        name: "editPerson",
        params: { code: pathOr(null, ["person", "code"], this.resourcesData) },
      });
      window.open(routeData.href, "_blank");
    },
    renderExecuteCaption(item, typeKey) {
      const typeKeys = {
        interview: this.$lang.interview_master,
        research: this.$lang.researcher,
      };
      return `${pathOr("", ["azmoon_execute", "caption"], item)}( ${pathOr(
        "",
        [typeKey],
        typeKeys
      )} ${pathOr("", ["operator", "name"], item)} ${pathOr(
        "",
        ["operator", "family"],
        item
      )} )`;
    },
    showExamPacks(item) {
      this.currentAzmoonExamPackItem = { ...item };
      this.showAzmoonLinksModal = true;
    },
    async fetchData() {
      try {
        this.$emit("setLoading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_resource.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.resourcesData = {
          ...pathOr({}, ["data", "data"], response),
        };
        this.personCode = pathOr(
          "",
          ["data", "data", "person", "code"],
          response
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("setLoading", false);
      }
    },
  },
};
</script>
